import { render, staticRenderFns } from "./SalaryGroupAddDialog.vue?vue&type=template&id=4d593601&scoped=true"
import script from "./SalaryGroupAddDialog.vue?vue&type=script&lang=js"
export * from "./SalaryGroupAddDialog.vue?vue&type=script&lang=js"
import style0 from "./SalaryGroupAddDialog.vue?vue&type=style&index=0&id=4d593601&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d593601",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d593601')) {
      api.createRecord('4d593601', component.options)
    } else {
      api.reload('4d593601', component.options)
    }
    module.hot.accept("./SalaryGroupAddDialog.vue?vue&type=template&id=4d593601&scoped=true", function () {
      api.rerender('4d593601', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employeeSalary/SalaryGroupAddDialog.vue"
export default component.exports